import { Flex, Text, Tooltip } from '@chakra-ui/react';
import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from '@morressier/alembic';
import { IJournals } from '@publishing-engine/domain/models';
import { ITags } from '@publishing-engine/domain/types/AuthorType';
import { useState } from 'react';
import TagDetailsPopover from 'src/components/Submission/AuthorsTab/AuthorProfileModal/TagDetailsPopover';

type IPropsType = {
  data: Array<ITags | IJournals>;
  hasIcon?: boolean;
  defaultLimit?: number;
};

export const RenderUserBadgeList = ({
  data,
  hasIcon = false,
  defaultLimit = 3
}: IPropsType) => {
  const [limit, setLimit] = useState(defaultLimit);

  return (
    <Flex wrap="wrap" gap={3}>
      {data.length
        ? data.slice(0, limit).map(d =>
            'description' in d ? (
              <Tooltip label={d.description}>
                <TagDetailsPopover key={d.id} tagDetail={d} />
              </Tooltip>
            ) : (
              <Badge whiteSpace={'break-spaces'}>
                <Flex
                  gap={1}
                  alignItems="center"
                  color={'neutralSecondaryContent'}
                  fontSize="sm"
                >
                  {hasIcon && <FontAwesomeIcon size="sm" icon={faUser} />}
                  <Text textStyle="textContext"> {d?.name}</Text>
                </Flex>
              </Badge>
            )
          )
        : hasIcon
        ? ''
        : 'No data available'}
      {limit > defaultLimit ? (
        <Badge onClick={() => setLimit(defaultLimit)} cursor="pointer">
          <Text textStyle="textContext">Show less</Text>
        </Badge>
      ) : data?.slice(limit, data.length).length ? (
        <Tooltip
          shouldWrapChildren
          hasArrow
          label={data
            ?.slice(limit, data.length)
            ?.map(d => d.name)
            .join(', ')}
          placement="top"
        >
          <Badge onClick={() => setLimit(data.length)} cursor="pointer">
            <Text textStyle="textContext">
              + {data.slice(limit, data.length).length}
            </Text>
          </Badge>{' '}
        </Tooltip>
      ) : null}
    </Flex>
  );
};
